import type { IUserRepository } from '../domain/IUserRepository'

export class DeleteUserUseCase {
    constructor(private readonly repository: IUserRepository) {}

    async execute(userId: number): Promise<void> {
        if (!userId || userId <= 0) {
            throw new Error('El ID del usuario es inválido')
        }

        await this.repository.delete(userId)
    }
}
